/* file description */

import type { UseSetVal } from './type';
import { COLUMN_FROM } from '../../../effects/consts';

export const useSetVal: UseSetVal = ({ onChange, field, columnFrom, form, treeData, config }) => {
  const selectTree = (val: string | number) => {
    const { options = [] } = field?.bizConfig || {};
    const SelectedRef = treeData.find((item: any) => item.userAccount === val);
    if (SelectedRef) {
      // 联动字段
      options.forEach((item: { moduleField: any; linkField: any }) => {
        const values: Record<any, any> = {};
        if (columnFrom === COLUMN_FROM.FORM) {
          values[item.moduleField] = SelectedRef[item.linkField];
          form.setFieldsValue(values);
        }
        if (columnFrom === COLUMN_FROM.TABLE) {
          const tableKey = config.rowIndex;
          values[tableKey] = {};
          values[tableKey][item.moduleField] = SelectedRef[item.linkField];
          form.setFieldsValue(values);
        }
      });
    }
    onChange?.(val);
  };
  return {
    selectTree,
  };
};
